import { RouteConfig } from 'vue-router'
import Home from '../views/Chat.vue'
import Offline from '../views/Offline.vue'
import { Store } from 'vuex'
import ProfileView from '@/modules/profile/views/Profile.vue'

export function createProfileRoutes (store: Store<any>): RouteConfig[] {
  return [
    {
      path: '/profile',
      name: 'profile',
      component: ProfileView,
      beforeEnter (to, from, next) {
        next()
      }
    }

  ]
}
